import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUserRequest, PnaDetailsDto } from '../interfaces/users';
import { apiEndpoints } from '../../core/constants/api-endpoints';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}
  userEmail = sessionStorage.getItem('UserEmail') || '';

  getBuyers(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.userBuyerList);
  }

  getLocations(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.LocationList);
  }

  getOfficesList(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.purchasingCodeList);
  }

  deletePnaRequests(pnaIds: number[]): Observable<HttpResponse<any>> {
    const deleteDto = { PnaIds: pnaIds };
    return this.httpUtilityService.post<any>(
      apiEndpoints.pnadeleterequest,
      deleteDto
    );
  }

  searchRequests(requestDto: any): Observable<HttpResponse<IUserRequest[]>> {
    return this.httpUtilityService.post<IUserRequest[]>(
      apiEndpoints.userPnaSearch,
      requestDto
    );
  }

  getItemList(pnaNoTemp: number): Observable<HttpResponse<any[]>> {
    const url = `${apiEndpoints.userItemList}?pna_no_temp=${pnaNoTemp}`;

    return this.httpUtilityService.get<any[]>(url);
  }

  getRequestDetails(pnaNo: string, year: string): Observable<any> {
    const url = `${apiEndpoints.getpna}?pnaNo=${pnaNo}&pnaYear=${year}`;
    return this.httpUtilityService.get<PnaDetailsDto>(url);
  }

  withdraw(pnano: string, email: string) {
    let url = `${apiEndpoints.withdraw}?pnano=${encodeURIComponent(
      pnano
    )}&email=${encodeURIComponent(email)}`;
    return this.httpUtilityService.post<any[]>(url, {});
  }

  deleteItems(items: any): Observable<any> {
    return this.httpUtilityService.post<any[]>(apiEndpoints.deleteItem, items);
  }

  createPnaIdTemp(userEmail: string): Observable<any> {
    const url = `${
      apiEndpoints.CreatePnaIdTemp
    }?user_email=${encodeURIComponent(userEmail)}`;

    return this.httpUtilityService.get<any>(url);
  }

  getCcnBranch(id: any): Observable<HttpResponse<any>> {
    const url = `${apiEndpoints.pnaRequestgetCcnBranch}/${id}`;
    return this.httpUtilityService.get<any>(url);
  }

  saveOrUpdatePnA(url: any, data: any): Observable<HttpResponse<any>> {
    return this.httpUtilityService.post<any>(url, data);
  }

  searchUserByEmail(email: any) {
    const url = `${apiEndpoints.searchUserByEmail}/${encodeURIComponent(
      email
    )}`;
    return this.httpUtilityService.get<any>(url);
  }
}
